<script setup>
import { getLocation } from '@weathernews/btos-javascript-modules/src/wniutil/gps.js'
import { ref } from 'vue'
import { VueSpinnerPuff } from 'vue3-spinners'

const { $Swal } = useNuxtApp()
const isLoading = ref(false)

const getGPSLocation = async () => {
  isLoading.value = true
  try {
    const llinfo = await getLocation()
    navigateTo(`/clothes/gps.html?lat=${llinfo.lat}&lon=${llinfo.lon}`, { external: true })
  } catch (e) {
    $Swal.fire({
      title: '',
      text: '位置情報の取得に失敗しました。端末の設定を確認してください。',
      icon: 'warning'
    })
    console.error(e)
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div class="clothesLocation">
    <button
      class="button"
      :disabled="isLoading"
      @click="getGPSLocation"
    >
      <p class="text">
        現在地付近の服装予報
      </p>
    </button>

    <!-- 画面全体に表示されるローディングインジケーター -->
    <div
      v-if="isLoading"
      class="fullscreen-loading-indicator"
    >
      <div class="loading-content">
        <VueSpinnerPuff
          color="#ffffff"
          size="70"
        />
        <p class="loading-text">
          位置情報を取得中...
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.clothesLocation {
  position: relative;
  margin-top: -30px;
  margin-inline: -10px;
  padding: 10px;
  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 355px;
    height: 40px;
    margin-inline: auto;
    padding: 7px;
    border-radius: 100vmax;
    background-color: #3569C0;
    border: 2px solid #3569C0;
    box-shadow: 2px 2px 1px 0 rgb(0 0 0 / .25);
    text-align: center;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
  .text {
    padding-left: 30px;
    padding-right: 40px;
    color: #fff;
    font-size: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-decoration: underline;
    background-image: url('https://gvs.weathernews.jp/clothes/images/icon/icon_location_white.svg'), url('https://gvs.weathernews.jp/clothes/images/icon/icon_clothes_white.svg');
    background-position: left center, right center;
    background-repeat: no-repeat;
    background-size: contain;
    span {
      font-size: 16px;
    }
  }
  @media (any-hover: hover) {
    .button {
      transition: transform .2s ease-in-out;
      &:not(:disabled):hover {
        transform: translateY(2px)
      }
    }
  }
}
.main {
  .clothesLocation {
    @media (min-width: 830px) {
      margin-inline: 0;
      padding: 10px;
    }
  }
}

// 画面全体に表示されるローディングインジケーター
.fullscreen-loading-indicator {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  pointer-events: all;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-text {
  margin-top: 15px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}
</style>
